import React from 'react';
import { FaDownload } from 'react-icons/fa';
import { Button, SearchBox } from '../../common';
// import { useIdentityContext } from '../../../context/IdentityContext';
import './Header.css';

const Header = ({
  title,
  subtitle,
  showSearch = true,
  showSync = true,
  showExport = false,
  onSearch,
  onExport,
  searchValue = '',
  children
}) => {
  // const { syncing, syncIdentities, dataSource } = useIdentityContext();

  // const handleSync = async () => {
  //   const result = await syncIdentities();
  //   if (result.success) {
  //     // Could show toast notification here
  //     console.log('Sync successful');
  //   }
  // };

  // const getDataSourceInfo = () => {
  //   switch (dataSource) {
  //     case 'live':
  //       return { icon: <FaCloud />, label: 'Live Data', className: 'live' };
  //     case 'mock':
  //       return { icon: <FaDatabase />, label: 'Demo Mode', className: 'mock' };
  //     default:
  //       return { icon: <FaDatabase />, label: 'Unknown', className: 'unknown' };
  //   }
  // };

  // const sourceInfo = getDataSourceInfo();

  return (
    <header className="header">
      <div className="header-left">
        <div className="header-title-section">
          <h1 className="header-title">{title}</h1>
          {subtitle && <p className="header-subtitle">{subtitle}</p>}
        </div>
        
        {/* <div className={`data-source-badge ${sourceInfo.className}`}>
          {sourceInfo.icon}
          <span>{sourceInfo.label}</span>
        </div> */}
      </div>

      <div className="header-right">
        {showSearch && onSearch && (
          <SearchBox
            value={searchValue}
            onChange={onSearch}
            placeholder="Search identities..."
          />
        )}

        {/* {showSync && (
          <Button
            variant="primary"
            icon={<FaSync className={syncing ? 'spin' : ''} />}
            loading={syncing}
            onClick={handleSync}
          >
            Sync
          </Button>
        )} */}

        {showExport && onExport && (
          <Button
            variant="outline"
            icon={<FaDownload />}
            onClick={onExport}
          >
            Export
          </Button>
        )}

        {children}
      </div>
    </header>
  );
};

export default Header;